/* The filter drawer's behaviour. Markup in sections/sjt-facets.liquid, styles
   in assets/component-sjt-facets.css.

   DELIBERATELY SMALL. The drawer this replaces needed a MutationObserver on
   the whole body to put itself back together after every AJAX re-render, and
   the condition it used to decide when to do that — "is the drawer open" —
   was false exactly when the markup had just been replaced. Nothing here
   re-renders: the panel is a GET form and Apply navigates, so there is no
   state to rebuild and no observer. This file opens it, closes it, and
   expands a long list.

   No framework, no custom elements: the section ships one copy of this per
   page and it must work the moment it parses. */
(function () {
  var LOCKS = ['overflow-hidden', 'overflow-hidden-mobile', 'overflow-hidden-tablet'];

  function open(root) {
    var panel = root.querySelector('[data-sjtf-panel]');
    var scrim = root.querySelector('.sjtf__scrim');
    if (!panel) return;
    panel.hidden = false;
    if (scrim) scrim.hidden = false;
    /* The page behind must not scroll with the drawer open, and `position:
       fixed` on the body is what loses the reader's place — so the class the
       theme already uses, plus the scroll position held and restored by hand. */
    root._y = window.scrollY;
    document.body.classList.add('overflow-hidden');
    /* Focus the PANEL, not the close button. Focusing a control draws its
       focus ring, and a box around the × the moment the drawer opens reads as
       a mistake. The panel takes focus so the keyboard and screen reader land
       inside the drawer without anything looking pressed. */
    panel.tabIndex = -1;
    panel.focus({ preventScroll: true });
  }

  function close(root) {
    var panel = root.querySelector('[data-sjtf-panel]');
    var scrim = root.querySelector('.sjtf__scrim');
    if (panel) panel.hidden = true;
    if (scrim) scrim.hidden = true;
    /* ALL THREE. Which lock the theme reaches for depends on the breakpoint it
       thinks it is at, and a class removed that was never added leaves the page
       unscrollable — measured on 14 Oct, body kept `overflow: hidden` after the
       drawer had closed. */
    for (var i = 0; i < LOCKS.length; i++) document.body.classList.remove(LOCKS[i]);
    var open = root.querySelector('[data-sjtf-open]');
    if (open) open.focus({ preventScroll: true });
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    var opener = t.closest('[data-sjtf-open]');
    if (opener) { open(opener.closest('[data-sjtf]')); return; }

    var closer = t.closest('[data-sjtf-close]');
    if (closer) { close(closer.closest('[data-sjtf]')); return; }

    var more = t.closest('[data-sjtf-more]');
    if (more) {
      var list = more.parentElement.querySelector('.sjtf__list');
      if (list) { list.classList.add('is-open'); more.remove(); }
      return;
    }

    /* Sort is chips over a hidden input, so the form carries one value and the
       shop's own sort options stay the source of truth. */
    var chip = t.closest('[data-sjtf-sortval]');
    if (chip) {
      var root = chip.closest('[data-sjtf]');
      var field = root && root.querySelector('[data-sjtf-sort]');
      if (field) field.value = chip.getAttribute('data-sjtf-sortval');
      var all = chip.parentElement.querySelectorAll('.sjtf__chip');
      for (var i = 0; i < all.length; i++) all[i].classList.remove('is-on');
      chip.classList.add('is-on');
      return;   /* sort does not move the count, so nothing to re-ask */
    }
  });

  /* ── what the button promises ──────────────────────────────────────────
     The form does not re-render, so nothing updates the counts on its own.
     Rather than reassemble the drawer — the exact thing that used to break it
     — ask the shop for the number alone, through the `count` view, and write
     it into the button. A few bytes, and the markup is never touched.

     Arithmetic would not do: summing the ticked values is only right inside a
     single group, and only for a filter a product can have one of. Two groups
     combine with AND, and a garment carries several crafts. Asking is the only
     honest answer. */
  var pending = null, seq = 0;

  function params(form) {
    var q = new URLSearchParams();
    var els = form.querySelectorAll('input[name], select[name]');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.type === 'checkbox' && !el.checked) continue;
      if (!el.value || !el.value.trim()) continue;
      q.append(el.name, el.value.trim());
    }
    return q;
  }

  function refresh(form) {
    var root = form.closest('[data-sjtf]');
    var apply = form.querySelector('.sjtf__apply');
    var head = form.querySelector('.sjtf__count');
    if (!apply) return;
    var mine = ++seq;
    var q = params(form);
    q.set('view', 'count');
    fetch(form.getAttribute('action') + '?' + q.toString(), { headers: { 'X-Requested-With': 'fetch' } })
      .then(function (r) { return r.ok ? r.text() : null; })
      .then(function (t) {
        if (mine !== seq || t === null) return;       /* a later edit already won */
        var n = (t.match(/\d[\d,]*/) || [])[0];
        if (!n) return;
        apply.textContent = 'Show ' + n + ' pieces';
        if (head) head.textContent = n + ' products';
      })
      .catch(function () { /* leave the last honest number in place */ });
  }

  document.addEventListener('change', function (e) {
    var form = e.target.closest ? e.target.closest('[data-sjtf-panel]') : null;
    if (!form) return;
    clearTimeout(pending);
    pending = setTimeout(function () { refresh(form); }, 220);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var panel = document.querySelector('.sjtf__panel:not([hidden])');
    if (panel) close(panel.closest('[data-sjtf]'));
  });

  /* An empty price box must not become `filter.v.price.gte=` in the URL, which
     Shopify reads as a real bound and which would survive every later change. */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('[data-sjtf-panel]')) return;
    var fields = form.querySelectorAll('input[type="number"], input[type="checkbox"]');
    for (var i = 0; i < fields.length; i++) {
      var f = fields[i];
      if (f.type === 'number' && f.value.trim() === '') f.disabled = true;
      if (f.type === 'checkbox' && !f.checked) f.disabled = true;
    }
  });
})();
